import { type Static, type TSchema, Type } from 'typebox';
import * as TypeCompiler from 'typebox/compile';

export const Nullable = <T extends TSchema>(schema: T) =>
  Type.Union([schema, Type.Null()]);

export const ReadonlyNullable = <T extends TSchema>(schema: T) =>
  Type.Readonly(Nullable(schema));

export const ReadonlyOptional = <T extends TSchema>(schema: T) =>
  Type.Readonly(Type.Optional(schema));

export const ReadonlyOptionalNullable = <T extends TSchema>(schema: T) =>
  ReadonlyOptional(Type.Union([Nullable(schema), Type.Undefined()]));

export type LocString = Static<typeof LocString>;
export const LocString = Type.Record(
  Type.String(),
  Type.Union([Type.String(), Type.Null(), Type.Undefined()]),
);
export const LocStringChecker = TypeCompiler.Compile(LocString);

export function getFromLocString(
  locStr: LocString | undefined,
  languageCode: string,
): string | undefined {
  if (locStr == null) {
    return undefined;
  }

  const val = locStr[languageCode];
  if (val == null) {
    return undefined;
  } else {
    return val;
  }
}

export type FieldValue = LocString | string | boolean | number | null;

export interface ExtraInfo {
  version?: number;
  was_overruled: boolean;
  was_recategorized?: boolean;
  intended_value: FieldValue;
  update_value?: FieldValue;
  input_language_code?: string;
}
